import useContentStore from "../redux/stores/contentStore";
import languages from "../language";

function getTransValueRec(name, where){
    // console.log(name, where);
    let trans = "";
    if(Array.isArray(name) && name.length > 1){
        let newWhere = where[name.shift()]; //side effect
        trans = getTransValueRec(name, newWhere);
    }
    else
        trans = where?.[name] ?? "";
    return trans;
}

export default function useTranslator(){
    const language = useContentStore((state) => state.language);

    return function(name, config){
        const { dictionary = languages[language], } = config ?? {};
        let trans = getTransValueRec(name, dictionary);
        if( typeof trans === "function")
            trans = trans();
        return trans;
    };
}
